import { useProducts } from "../../../hooks/useProducts";
import "./homeproductsshow.css";
import Homeproduct from "./homeproduct";
import { useState, useEffect } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { getImageUrl } from '../../../utils/imageUtils';

export default function Homeproductsshow({
    sharedState,
    currentproducts,
    setcurrentproducts,
    searchQuery,
    currentPage,
    wishlist,
    setWishlist
}) {
    const { products, isLoading, error } = useProducts();
    const { t } = useTranslation();
    const [displayedProducts, setDisplayedProducts] = useState([]);


    const searchProducts = (query) => {
        if (!query.trim()) return [];
        const searchTerm = query.toLowerCase().trim();
        return products.filter(product =>
            product.name.toLowerCase().includes(searchTerm) ||
            (product.description && product.description.toLowerCase().includes(searchTerm)) ||
            (product.category && product.category.toLowerCase().includes(searchTerm))
        );
    };

    const getProductsByCollection = (collection) => {
        if (collection === "btn-1") return products;
        if (collection.startsWith('btn-7-')) {
            if (collection === 'btn-7-0') {
                return products.filter(p => p.collection?.startsWith('btn-7-'));
            }
            return products.filter(p => p.collection === collection);
        }
        return products.filter(p => p.collection === collection);
    };

    useEffect(() => {
        let filtered = [];
        if (sharedState.startsWith('search-')) {
            const query = sharedState.replace('search-', '');
            filtered = searchProducts(query);
        } else {
            filtered = getProductsByCollection(sharedState);
        }
        setcurrentproducts(filtered);
    }, [sharedState, products]);

    useEffect(() => {
        const start = (currentPage - 1) * 20;
        const end = start + 20;
        setDisplayedProducts(currentproducts.slice(start, end));
    }, [currentproducts, currentPage]);

    if (isLoading) {
        return <div className="loading-container"><p>جاري تحميل المنتجات...</p></div>;
    }

    if (error) {
        return <div className="error-container"><p>حدث خطأ: {error.message}</p></div>;
    }

    return (
        <div className="container">
            <div className="home-products-show">
                {displayedProducts.map((data) => (
                    <Homeproduct
                        key={data.id}
                        id={data.id}
                        name={data.name}
                        price={data.price}
                        img={getImageUrl(data.mainImage)}
                        wishlist={wishlist}
                        setWishlist={setWishlist}
                    />
                ))}
            </div>
        </div>
    );
}